import { render } from "./ExamUploadOffcanvas.vue?vue&type=template&id=c1ebe9b0&scoped=true"
import script from "./ExamUploadOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamUploadOffcanvas.vue?vue&type=script&lang=js"

import "./ExamUploadOffcanvas.vue?vue&type=style&index=0&id=c1ebe9b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ebe9b0"]])

export default __exports__